import React from "react";
import classNames from "classnames/bind";
import styles from "../../AddJobModal.module.scss";
import BaseAddressInput from "~/components/common/base-address-input/BaseAddressInput";
import { JobFormData, JobFormErrors } from "../../types/add-job.types";
import PrimaryInput from "~/components/common/primary-input/PrimaryInput";

const cx = classNames.bind(styles);

interface NewContactFormProps {
  formData: JobFormData;
  errors: JobFormErrors;
  onFieldChange: (field: keyof JobFormData, value: any) => void;
  onAddressChange: (value: string) => void;
  onAddressSuggestionSelect: (suggestion: any) => void;
}

const NewContactForm: React.FC<NewContactFormProps> = ({
  formData,
  errors,
  onFieldChange,
  onAddressChange,
  onAddressSuggestionSelect,
}) => {
  return (
    <div className={cx("form-content")}>
      <PrimaryInput
        name="name"
        label="Name"
        placeholder="Enter full name"
        value={formData.name}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onFieldChange("name", e.target.value)
        }
        className={cx("form-input")}
        errorMessage={errors.name}
      />

      <PrimaryInput
        name="email"
        label="Email"
        placeholder="Enter email address"
        value={formData.email}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onFieldChange("email", e.target.value)
        }
        className={cx("form-input")}
        errorMessage={errors.email}
      />

      <PrimaryInput
        name="phoneNumber"
        label="Phone Number"
        placeholder="Enter phone number"
        value={formData.phoneNumber}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onFieldChange("phoneNumber", e.target.value)
        }
        className={cx("form-input")}
        errorMessage={errors.phoneNumber}
      />

      <BaseAddressInput
        value={formData.address}
        onChange={onAddressChange}
        onSuggestionSelect={onAddressSuggestionSelect}
        placeholder="Enter full address"
        label="Billing Address"
        errorMessage={errors.address}
      />

      <div className={cx("checkbox-container", "mt-4")}>
        <input
          type="checkbox"
          checked={formData.needAppointment}
          onChange={(e) => onFieldChange("needAppointment", e.target.checked)}
          className={cx("checkbox")}
        />
        <label className={cx("checkbox-label")}>Need Appointment</label>
      </div>
    </div>
  );
};

export default NewContactForm;
